module.exports = "/_next/static/images/icon-down-82bba937.png";